export interface AuthTokenClaims {
	companyId: number | null;
	isSuperUser: boolean;
	isStaff: boolean;
	subject: string | null;
}

const DEFAULT_CLAIMS: AuthTokenClaims = {
	companyId: null,
	isSuperUser: false,
	isStaff: false,
	subject: null,
};

// Decodes the identity claims carried on a login/refresh JWT's payload segment
// (company_id/companyId, is_superuser, is_staff, sub). Tolerant of malformed or
// non-JWT tokens — returns safe defaults instead of throwing, since callers
// treat a login response as trusted transport, not a guaranteed well-formed
// JWT (e.g. legacy/mocked tokens).
export const decodeAuthTokenClaims = (accessToken: string): AuthTokenClaims => {
	try {
		const payloadSegment = accessToken.split('.')[1] ?? '';
		// Payloads are base64url, not base64 — atob throws on '-'/'_' and would
		// otherwise silently fall through to the defaults below.
		const payload = JSON.parse(atob(payloadSegment.replace(/-/g, '+').replace(/_/g, '/')));
		const sub: unknown = payload.sub;
		return {
			companyId: payload.company_id ?? payload.companyId ?? null,
			isSuperUser: payload.is_superuser === true,
			isStaff: payload.is_staff === true,
			subject: typeof sub === 'string' ? sub : typeof sub === 'number' ? String(sub) : null,
		};
	} catch {
		return DEFAULT_CLAIMS;
	}
};
